import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Separator } from "./ui/separator";
import { Facebook, Twitter, Instagram, Youtube, MessageCircle, Phone, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-red-900 to-red-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Premium Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Premium Services</h3>
            <ul className="space-y-2 text-red-100">
              <li><a href="#" className="hover:text-white transition-colors">Pairing In Horoscope Kundli</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Best Consultation Call</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Future Report</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Kundali Matching</a></li>
            </ul>
          </div>

          {/* Our Courses */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Our Courses</h3>
            <ul className="space-y-2 text-red-100">
              <li><a href="#" className="hover:text-white transition-colors">Basic Numerology Course</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Basic Astrology Course</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Advanced Numerology</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Course</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Advanced Astrology Course</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Master Astrology Course</a></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2 text-red-100">
              <li><a href="#" className="hover:text-white transition-colors">Daily Horoscope</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Numerology 2024</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Destiny Number Calculator</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Collaborate With Us</a></li>
              <li><a href="#" className="hover:text-white transition-colors">About Us</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Careers</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Contact Us</a></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Subscribe To Our Newsletter</h3>
            <div className="space-y-4">
              <div className="flex gap-2">
                <Input
                  placeholder="Email..."
                  className="bg-white text-black"
                />
                <Button className="bg-orange-500 hover:bg-orange-600 text-white">
                  →
                </Button>
              </div>
              <p className="text-red-100 text-sm">
                Acharya LavBhushan is the best astrologer in Delhi in the field of Astrology, Numerology & Palmistry. He is helping people to solve their life problems related to government jobs, love marriage, and all other life issues since 20+ years.
              </p>
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-red-700" />

        {/* Contact Details and Astrologers */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Contact Details</h3>
            <div className="space-y-2 text-red-100">
              <p className="flex items-center gap-2">
                <Phone className="w-4 h-4" />
                +91 9844692552 (Enquiry)
              </p>
              <p className="flex items-center gap-2">
                <MessageCircle className="w-4 h-4" />
                Gopal Gowda!
              </p>
              <p className="flex items-center gap-2">
                <Phone className="w-4 h-4" />
                +91 7259404556 (Sales)
              </p>
              <p className="flex items-center gap-2">
                <Phone className="w-4 h-4" />
                +91 7259404564 (Support)
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Astrologers</h3>
            <div className="text-red-100">
              <p>Acharya LavBhushan Jyotish</p>
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-red-700" />

        {/* Bottom section */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center gap-4 mb-4 md:mb-0">
            <div className="text-white font-bold text-xl">
              Acharya LavBhushan
            </div>
          </div>

          <div className="flex flex-wrap gap-4 text-red-100 text-sm">
            <a href="#" className="hover:text-white">Help</a>
            <a href="#" className="hover:text-white">Terms & Conditions</a>
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Refund Policy</a>
          </div>

          <div className="flex gap-4 mt-4 md:mt-0">
            <Facebook className="w-5 h-5 text-red-100 hover:text-white cursor-pointer" />
            <Twitter className="w-5 h-5 text-red-100 hover:text-white cursor-pointer" />
            <Instagram className="w-5 h-5 text-red-100 hover:text-white cursor-pointer" />
            <Youtube className="w-5 h-5 text-red-100 hover:text-white cursor-pointer" />
          </div>
        </div>

        <div className="text-center mt-8 text-red-100 text-sm">
          © All rights reserved by Acharya LavBhushan
        </div>
      </div>

      {/* Bottom CTA */}
      <div className="bg-gradient-to-r from-pink-500 to-pink-600 text-white text-center py-3">
        <p className="font-semibold">Hurry! Offer Ends Soon</p>
      </div>
    </footer>
  );
};

export default Footer;